module.exports = __webpack_public_path__ + "static/img/develop-blast2.b1fef6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/develop-blast2.jpg
// module id = FYO2
// module chunks = 1